import { Injectable } from '@angular/core';
import { OrderDetails } from 'src/app/models/data/order.model';
import { CloudFunctionsService } from 'src/app/services/firebase/cloud.functions.services';
import { INTEGRATION } from 'src/app/core/constants/integration.constants';
import { from, of } from 'rxjs';
import { RTDBService } from '../firebase/rtdb.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  constructor(private cloudFunction: CloudFunctionsService, private rtdb: RTDBService) {}

  getDailyReports(branch, year, month, node) {
    return this.rtdb.getDailyReports(branch, year, month, node);
  }

  getMonthlyReports(branch, year, node) {
    return this.rtdb.getMonthlyReports(branch, year, node);
  }

  getWeeklyReports(branch, year, node) {
    return this.rtdb.getWeeklyReports(branch, year, node);
  }
}
